import React, {FC} from "react";
import {Box, Typography, useTheme} from "@material-ui/core";

const LegendDot: FC<{ variant: "order" | "availability" | "nothing", label: string }> = ({variant, label}) => {
    const theme = useTheme();
    const colorMap = {
        order: theme.palette.warning.light,
        availability: theme.palette.primary.main,
        nothing: theme.palette.background.default
    }
    return (
        <div style={{display: "inline-flex", alignItems: "center", marginBottom: 16}}>
            <span
                style={{
                    width: 22,
                    height: 22,
                    marginRight: 12,
                    borderRadius: "50%",
                    backgroundColor: colorMap[variant],
                    border: variant === "nothing" ? "solid grey 0.2px" : undefined
                }}/>
            <Typography>{label}</Typography>
        </div>
    );
};

export const CalendarLegend: FC = () => {
    return (
        <Box display="flex" flexDirection="column" marginTop={3} paddingLeft={1}>
            <LegendDot variant={"availability"} label={"Verfügbar"}/>
            <LegendDot variant={"order"} label={"Gebucht"}/>
            <LegendDot variant={"nothing"} label={"Nicht verfügbar"}/>
        </Box>
    )
}